import type { SchemeConfigFormValues } from './PricingWizardSchemeConfigurationStep';

export const defaultValues: SchemeConfigFormValues = {
  holiday_fee_cents: 0,
  observed_holidays: [],
  stair_fee_type: '',
  stair_fee_cents: 0,
  minimum_steps: 0,
  base_fee_cents: 0,
  minimum_price_cents: 0,
  loaded_mileage_rate_cents: 0,
  free_loaded_miles: 0,
  long_distance_mileage_rate_cents: 0,
  long_distance_mileage_start: 0,
  unloaded_mileage_rate_cents: 0,
  free_unloaded_miles: 0,
  unloaded_return_mileage_rate_cents: 0,
  free_unloaded_return_miles: 0,
  wait_time_rate_cents: 0,
  wait_time_period_minutes: 0,
  wait_time_free_minutes: 0,
  late_cancellation_fee_cents: 0,
  late_cancellation_period_minutes: 0,
  late_cancellation_fee_type: '',
  late_cancellation_fee_percentage: 0,
  no_show_fee_type: '',
  no_show_fee_cents: 0,
  no_show_fee_percentage: 0,
  additional_attendant_rate_cents: 0,
  additional_passenger_rate_cents: 0,
  bariatric_passenger_fee_cents: 0,
  wheelchair_rental_fee_cents: 0,
  after_hours_fee_cents: 0,
  business_hours_start_time: undefined,
  business_hours_end_time: undefined,
  oxygen_fee_cents: 0,
  weekend_fee_cents: 0,
  infectious_disease_fee_cents: 0,
  same_day_booking_fee_cents: 0,
  car_seat_fee_cents: 0,
  booster_seat_fee_cents: 0,
  ride_alone_fee_cents: 0,
  mileage_rounding: 'none',
  price_rounding: 'none',
  price_rounding_interval: undefined,
};
